// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// El maestro de empleados vive en /employee y el módulo de Personal solo lo
// consume: no se duplica esa fuente. Mismo contrato que
// pages/parametrizacion/employees/Services/employees.services.jsx
// (POST con { limit, offset, query } y respuesta { data, totalRecords }).
export const fetchPersonalEmpleados = async ({ limit = 500, offset = 1, query = {} } = {}) => {
  const response = await fetch(`${API_URL}/employee/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ limit, offset, query }),
  });

  if (!response.ok) {
    throw new Error('No fue posible cargar los empleados');
  }

  const data = await response.json().catch(() => ({}));
  return {
    data: data?.data || [],
    total: data?.totalRecords ?? (data?.data || []).length,
  };
};